// extracted by mini-css-extract-plugin
export var icon = "_4c-1";
export var subtext = "_4c-0";